import ChartBzdnAfbouw from "../../../../src/client/vvgn/json/bzdn-afbouw.json";
import ChartBasicSchematic from "../../../../src/components/interactions/basic-schematic/Chart.js";
import * as React from 'react';
export default {
  ChartBzdnAfbouw,
  ChartBasicSchematic,
  React
};